import { FC } from 'react';
import { OrdersListItem } from './OrdersListItem';
import { InvoiceOut, OrderOut } from '../../store/api';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly orders: ReadonlyArray<OrderOut>;
    readonly onDownloadInvoice: (invoice: InvoiceOut) => void;
};

export const OrdersList: FC<Props> = ({ orders, onDownloadInvoice }) => {
    const { t } = useTranslation();
    return (
        <table className="sum">
            <thead>
                <tr>
                    <th>{t('shop.orders.orderNumber')}</th>
                    <th>{t('shop.orders.orderDate')}</th>
                    <th>{t('shop.orders.account')}</th>
                    <th>{t('shop.orders.addedToCollection')}</th>
                    <th>{t('shop.orders.orderQuantities')}</th>
                    <th>{t('shop.orders.orderTotal')}</th>
                    <th>{t('shop.orders.status')}</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {orders.map(order => {
                    return <OrdersListItem key={order.id} order={order} onDownloadInvoice={onDownloadInvoice} />;
                })}
            </tbody>
        </table>
    );
};
